import axios from "../axios-auth";
import orginal_axios from "axios";

export const customerShopService = {
    getCustomerShops,
    getCustomerShopDetail,
    saveCustomerShop,
    getAllCustomerShop,
    getAll,
    saveCustomerShopExcel,
    getCustomerShopExcelTemplate
};

function getCustomerShops(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.code) {
        params["code"] = searchParams.code;
    }

    if (searchParams.type) {
        params["type"] = searchParams.type;
    }

    if (searchParams.shopTypeId) {
        params["shopTypeId"] = searchParams.shopTypeId;
    }

    if (searchParams.township) {
        params["township"] = searchParams.township;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    if (typeof (searchParams.isNoRegion) == 'boolean') {
        params["isNoRegion"] = searchParams.isNoRegion;
    }

    return axios.get("/auth/customer-shop", { params });
}

function getCustomerShopDetail(id) {
    return axios.get("/auth/customer-shop/" + id);
}

function saveCustomerShop(customerShop) {
    if (!customerShop.id) {
        //new customer shop
        return axios.post("/auth/customer-shop", customerShop);
    }
    else {
        //edit
        return axios.put("/auth/customer-shop", customerShop);
    }
}

function getAllCustomerShop(searchParams) {
    let params = {
        sort: "code,asc"
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.code) {
        params["code"] = searchParams.code;
    }

    if (searchParams.type) {
        params["type"] = searchParams.type;
    }

    if (searchParams.shopTypeId) {
        params["shopTypeId"] = searchParams.shopTypeId;
    }

    if (searchParams.township) {
        params["township"] = searchParams.township;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }

    if (typeof (searchParams.isNoRegion) == 'boolean') {
        params["isNoRegion"] = searchParams.isNoRegion;
    }
    return axios.get("/auth/customer-shop", { params });
}

function getAll() {
    return axios.get("/auth/customer-shop");
}

function saveCustomerShopExcel(file) {
    return axios.post('/auth/customer-shop/excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function getCustomerShopExcelTemplate() {
    return orginal_axios({
      method: "GET",
      url: axios.defaults.baseURL + "/auth/customer-shop/excel-template",
      responseType: "arraybuffer", // important
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    }).then(function (response) {
      return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
  }